export default __webpack_public_path__ + "static/media/logo_light.cd082fb2.png";